module.exports = __webpack_public_path__ + "img/advisory_solve3_icon_02.d830e6aa.png";